import { alias, object, primitive, serializable } from "serializr";
import QuestionModel from "../../ExerciseModal/Question.model";

export class Paper {
  @serializable(alias("id", primitive()))
  id?: number;

  @serializable(alias("title", primitive()))
  title?: string;

  @serializable(alias("deadline", primitive()))
  deadline?: string;

  @serializable(alias("correct_answer_point", primitive()))
  correctAnswerPoint?: Float32Array;

  @serializable(alias("penalty_point", primitive()))
  penaltyPoint?: Float32Array;

  @serializable(alias("timer_options", primitive()))
  timerOptions?: string;

  @serializable(alias("time", primitive()))
  time?: Float32Array;

  @serializable(alias("is_active", primitive()))
  isActive?: boolean;
}
export class PreviousPaperQuestionsModel extends QuestionModel {
  @serializable(alias("paper", object(Paper)))
  paper?: Paper;

  @serializable(alias("paper_id", primitive()))
  paperId?: Paper;
}
export class PreviousPaperModel {
  @serializable(alias("id", primitive()))
  id?: number;

  @serializable(alias("title", primitive()))
  title?: string;

  @serializable(alias("is_active", primitive()))
  isActive?: boolean;

  // @serializable(alias('deadline', primitive()))
  // deadline?: string;

  @serializable(alias("month", primitive()))
  month?: string;

  @serializable(alias("year", primitive()))
  year?: number;

  @serializable(alias("timer_options", primitive()))
  timerOptions?: string;

  @serializable(alias("time", primitive()))
  time?: Float32Array;

  @serializable(alias("correct_answer_point", primitive()))
  correctAnswerPoint?: number;

  @serializable(alias("penalty_point", primitive()))
  penaltyPoint?: number;

  @serializable(alias("exam_id", primitive()))
  examId?: number;
}
